var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMyNumberCardIcon = function SvgMyNumberCardIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.833 4.167c0-.46.373-.833.833-.833h16.667c.46 0 .833.373.833.833v1.667H.833zm0 4.167h18.333v8.333c0 .46-.373.833-.833.833H1.666a.833.833 0 0 1-.833-.833zm12.5 6.041a.625.625 0 1 0 0 1.25h3.333a.625.625 0 0 0 0-1.25zM8.541 15c0-.345.28-.625.625-.625h1.667a.625.625 0 1 1 0 1.25H9.166A.625.625 0 0 1 8.541 15",
    clipRule: "evenodd"
  })));
};
export default SvgMyNumberCardIcon;